export default function CreateYourProfileFormFooter({ initializing }) {
    return (
        <>
            <p>
                <span className='required'>*</span> Indicates required field.
            </p>

            <div className="flex-row">
                <div className="col-sm-12">
                    <button data-onboarding-button-id="CreateYourProfile:CreateYourProfileFormFooter:Continue"
                        type="submit"
                        className="btn btn--primary btn--full-mobile btn--pull-right"
                        disabled={initializing}
                    >
                        <span>Continue</span>
                    </button>
                </div>
            </div>
        </>
    );
}
